export const APP_VERSION = '96.8.0';

export const APP_STORE_ID = '414313281';
export const PLAY_STORE_ID = 'com.styleseat.promobile';

export const IOS_APP_URL = 'https://itunes.apple.com/us/app/styleseat-hair-nails-massage/id414313281?mt=8';
export const ANDROID_APP_URL = 'https://play.google.com/store/apps/details?id=com.styleseat.promobile&hl=en';

export const AUTH_ORIGINS = {
  BOOKING: 'booking',
  HEARTING: 'hearting photo details',
  PROFILE_LANDING_SIGNUP_WALL: 'profile landing signup wall',
  APP_SIGNUP_WALL: 'app signup wall',
  SIGNUP_URL_PARAMETER: 'signup url parameter',
  PROFILE_HEADER_ICON_FAV_PRO: 'profile header icon favorite pro',
  SIGNUP_PROMO_MODAL_FACEBOOK: 'signup promo modal facebook',
  SIGNUP_PROMO_MODAL_EMAIL: 'signup promo modal email',
  HOME_ACCOUNT_ACTIONS: 'home account actions',
  SIDEBAR: 'sidebar',
  HEADER_NAV: 'header',
  DEEP_LINK_BOOKING: 'deep link booking',
  REFERRAL_LANDING: 'referral landing page',
  PRO_VS_CLIENT_MODAL: 'pro vs client modal',
  LOGIN_PAGE: 'login page',
  PROFILE_SEND_MESSAGE: 'profile send message',
  SALON_SEND_MESSAGE: 'salon send message',
};
